const theme = {
  palette: {
    primary: {
      main: '#03A9F4'
    },
    secondary: {
        light: '#6ec6ff',
        main: window.location.origin.includes("https://app") ? '#000' : '#DEB059',
        dark: '#0069c0',
        contrastText: '#fff',
    }
  },
};

const loginTheme = {
  palette: {
    primary: {
      main: '#000'
    },
    secondary: {
        light: '#000',
        main: '#DEB059',
        contrastText: '#fff',
    }
  },
};

export { theme, loginTheme }

export default theme;